
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateBackupServerForm from '@/services/Backup/forms/CreateBackupServerForm';
import { BackupServerRepositoryInterface } from '@/services/Backup/interfaces/index';
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: {
    PageHeader,
  },
  inject: [
    'backupServerRepository',
  ],
})
export default class CreateBackupServer extends Vue {
  public backupServerRepository: BackupServerRepositoryInterface;

  public isLoading: boolean = false;
  public form: WPXFormValue<CreateBackupServerForm> = new WPXFormValue(CreateBackupServerForm);

  public async createBackupServer(): Promise<void> {
    try {
      this.isLoading = true;
      await this.backupServerRepository.createBackupServer({
        serverName: this.form.data.serverName
      });

      this.$successDialog.show(`Backup Server ${this.form.data.serverName} creation started!`);

    } catch (err) {
      this.onError(err);
    } finally {
      this.isLoading = false;
    }
  }

  private async onError(err: unknown): Promise<void> {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}
